import React from "react";

import cx from "classnames";

import styles from "~/billing/css/PaidFeatureInfoBlocks.module.css";

type ListItemProps = {
	icon: React.ReactNode;
	color: "royal" | "peach";
	title: string;
	subtitle: string;
};

type Props = {
	items: ListItemProps[];
};

const PaidFeatureInfoBlocks: React.FC<Props> = ({ items }) => {
	return (
		<div className={styles.container}>
			{items &&
				items.map(item => {
					const { icon, color, title, subtitle } = item;
					return (
						<div key={title} className={styles.paidFeatureListItem}>
							<div className={cx(styles.icon, { [styles[color]]: color != undefined })}>{icon}</div>
							<div className={styles.infoContainer}>
								<div className={styles.title}>{title}</div>
								<div className={styles.subtitle}>{subtitle}</div>
							</div>
						</div>
					);
				})}
		</div>
	);
};

export default PaidFeatureInfoBlocks;
